<template>
  <div class="staff-list">
    <vxe-table
      border
      resizable
      auto-resize
      :key="Math.random()"
      show-header-overflow
      show-overflow
      highlight-hover-row
      :data="staffNameList">
      <vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>
      <vxe-table-column field="name" title="姓名" minWidth="100" align="center"></vxe-table-column>
      <vxe-table-column field="jobTitle" title="职位" minWidth="100" align="center"></vxe-table-column>
      <vxe-table-column field="contTel" title="联系方式" minWidth="100" align="center"></vxe-table-column>
      <vxe-table-column field="address" title="个人证书" minWidth="200" show-overflow align="center"></vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
import {
  mapActions
} from "vuex";

export default {
  name: 'BaseInfo',
  data() {
    return {
      // 分页的参数配置
      tablePage: {
        totalResult: 0,
        currentPage: 1,
        pageSize: 10,
        align: "left",
        pageSizes: [10, 20, 50, 100, 500, 1000],
        perfect: true
      },
      staffNameList: [],
    }
  },
  computed: {},
  created() {
      this.initView()
  },
  methods: {
    ...mapActions([
      "getWorkPersonListServe2"
    ]),
    initView() {
      this.getStaffNameList()
    }, 
    // 查询员工名单
    getStaffNameList() {
      this.getWorkPersonListServe2({
        current: this.tablePage.currentPage,
        size: this.tablePage.pageSize,
        param: {
          compId: this.$route.params.id
        }
      }).then(res => {
        if (res.code == 200) {
          this.staffNameList = res.data.records;
          this.tablePage.totalResult = +res.data.total;
        }
      })
		}, 
  },
}
</script>
<style lang="scss" scoped>

</style>
